import { render, staticRenderFns } from "./AnswerPosList.vue?vue&type=template&id=1f11f6a1&scoped=true"
import script from "./AnswerPosList.vue?vue&type=script&lang=js"
export * from "./AnswerPosList.vue?vue&type=script&lang=js"
import style0 from "./AnswerPosList.vue?vue&type=style&index=0&id=1f11f6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f11f6a1",
  null
  
)

export default component.exports